import React, { Component, useState } from "react";
import "./index.scss";
import logoOutlet from '../../images/icons/outlet-live-logo.svg';
import { connect } from "react-redux";


class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }


  render() {
    const {loading} = this.props;
    return (
      <React.Fragment>
        <div className={`loadingio-spinner-ripple-pod74wfyirk ${loading ? '': 'hide-loading'}`}>
          <div className="loading-container">
            <img src={logoOutlet} className="logo-icon"/>
            <div className="ldio-se1ucuxedm">
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.app.loading
});

export default connect(mapStateToProps)(Loading);
